import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const MONTH_SALE_SCHEMA = Object.freeze({
    LABEL: '',
    TOTAL: '',
  }),
  RECORD = generateSchema(MONTH_SALE_SCHEMA),
  KEYS: any = generateKeys(MONTH_SALE_SCHEMA);

export class MonthSales extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get total(): string {
    return this.get(KEYS.TOTAL);
  }
}
